import { USER_ROLE, USER_ACCESS } from '@/constants/user'

export const items = [
  {
    title: 'Home',
    icon: 'mdi-home',
    to: 'home',
  },
  {
    title: 'Notifications',
    icon: 'mdi-bell',
    to: 'alerts',
    meta: {
      restrictedTo: [
        USER_ROLE.PLATFORM_ADMIN,
        USER_ROLE.TOP_ADMIN,
        USER_ROLE.CORPORATE,
        USER_ROLE.VIEWER,
        USER_ROLE.GROUPMANAGER,
        USER_ROLE.STOREMANAGER,
        USER_ROLE.MANAGER,
        USER_ROLE.CORPORATE,
      ],
    },
  },
  {
    title: 'Reports',
    icon: 'mdi-finance',
    group: 'tables',
    meta: {
      restrictedTo: [
        USER_ROLE.PLATFORM_ADMIN,
        USER_ROLE.TOP_ADMIN,
        USER_ROLE.CORPORATE,
        USER_ROLE.VIEWER,
        USER_ROLE.GROUPMANAGER,
        USER_ROLE.STOREMANAGER,
        USER_ROLE.MANAGER,
        USER_ROLE.CORPORATE,
      ],
    },
    children: [
      {
        title: 'Site Reports',
        to: 'reports',
        icon: 'mdi-chart-bar',
      },
      {
        title: 'Group Reports',
        to: 'reportsgroup',
        icon: 'mdi-chart-areaspline-variant',
        meta: {
          restrictedTo: [
            USER_ROLE.PLATFORM_ADMIN,
            USER_ROLE.TOP_ADMIN,
            USER_ROLE.CORPORATE,
          ],
        },
      },
      {
        title: 'Device Reports',
        to: 'reportsdevices',
        icon: 'mdi-chart-histogram',
        meta: {
          // restrictedTo: [
          //   USER_ROLE.PLATFORM_ADMIN,
          //   USER_ROLE.TOP_ADMIN

          // ],
        },
      },
    ],
  },
  {
    title: 'Deposits',
    icon: 'mdi-wallet',
    group: 'tables',
    meta: {
      restrictedTo: [
        USER_ROLE.PLATFORM_ADMIN,
        USER_ROLE.TOP_ADMIN,
        USER_ROLE.CORPORATE,
        USER_ROLE.VIEWER,
        USER_ROLE.GROUPMANAGER,
        USER_ROLE.STOREMANAGER,
        USER_ROLE.MANAGER,
        USER_ROLE.CORPORATE,
      ],
    },
    children: [
      {
        title: 'Deposit Management',
        to: 'depositactions',
        icon: 'mdi-store-edit',
        meta: {
          // restrictedTo: [
          //   USER_ROLE.PLATFORM_ADMIN,
          //   USER_ROLE.TOP_ADMIN
          // ],
        },
      },
      {
        title: 'Postal Management',
        to: 'postalactions',
        icon: 'mdi-email-edit',
        meta: {
          // restrictedTo: [
          //   USER_ROLE.PLATFORM_ADMIN,
          //   USER_ROLE.TOP_ADMIN

          // ],
        },
      },

    ],
  },
  // {
  //   title: 'Change System',
  //   icon: 'mdi-swap-horizontal-bold',
  //   group: 'tables',
  //   children: [
  //     {
  //       title: 'Change Order',
  //       to: 'changeorder',
  //       icon: 'mdi-truck-delivery-outline',
  //       meta: {
  //         restrictedTo: [
  //           USER_ROLE.PLATFORM_ADMIN,
  //           USER_ROLE.TOP_ADMIN

  //         ],
  //       },
  //     },
  //     {
  //       title: 'Change Profiles',
  //       to: 'changeorderprofiles',
  //       icon: 'mdi-group',
  //       meta: {
  //         restrictedTo: [
  //           USER_ROLE.PLATFORM_ADMIN,
  //           USER_ROLE.TOP_ADMIN

  //         ],
  //       },
  //     },
  //     {
  //       title: 'Change Shipment',
  //       to: 'changeordershipment',
  //       icon: 'mdi-postage-stamp',
  //       meta: {
  //         restrictedTo: [
  //           USER_ROLE.PLATFORM_ADMIN,
  //           USER_ROLE.TOP_ADMIN

  //         ],
  //       },
  //     },
  //     {
  //       title: 'Change Settings',
  //       to: 'changeordersettings',
  //       icon: 'mdi-cog-transfer',
  //       meta: {
  //         restrictedTo: [
  //           USER_ROLE.PLATFORM_ADMIN,
  //           USER_ROLE.TOP_ADMIN

  //         ],
  //       },
  //     },
  //     {
  //       title: 'Change Order Mgt',
  //       to: 'changeordermanagement',
  //       icon: 'mdi-file-cog',
  //       meta: {
  //         restrictedTo: [
  //           USER_ROLE.PLATFORM_ADMIN,
  //           USER_ROLE.TOP_ADMIN

  //         ],
  //       },
  //     },
  //   ],
  // },
  {
    title: 'Operations',
    icon: 'mdi-cog-sync-outline',
    group: 'tables',
    children: [
      {
        title: 'Change Management',
        to: 'changeorder',
        icon: 'mdi-chevron-up',
        meta: {
          restrictedTo: [
            USER_ROLE.PLATFORM_ADMIN,
            USER_ROLE.TOP_ADMIN

          ],
        },
        children: [
          {
            title: 'Change Order Frequency',
            icon: 'mdi-account-cog',
            to: 'changeordersettings',
          },
          {
            title: 'Change Order Profiles',
            icon: 'mdi-account-switch',
            to: 'changeorderprofiles',
          },
          {
            title: 'Change Order Admin',
            icon: 'mdi-account-convert',
            to: 'changeorderadmin',
          },
          {
            title: 'Change Order Shipments',
            icon: 'mdi-store-cog',
            to: 'changeordershipment',
          },
          {
            title: 'Site QR Codes',
            icon: 'mdi-qrcode',
            to: 'paythingssiteqr',
          },
        ]
        
      },
      {
        title: 'Postal Management',
        to: 'changeorder',
        icon: 'mdi-chevron-up',
        meta: {
          restrictedTo: [
            USER_ROLE.PLATFORM_ADMIN,
            USER_ROLE.TOP_ADMIN

          ],
        },
        children: [
          {
            title: 'Postal Dashboard',
            icon: 'mdi-email-multiple',
            to: 'Postaldashboard',
          },
          // {
          //   title: 'Postal Verify',
          //   icon: 'mdi-file-multiple',
          //   to: 'PostalVerifyManagement',
          // },
        ]
      },
      {
        title: 'Vault Management',
        to: 'changeorder',
        icon: 'mdi-chevron-up',
        meta: {
          restrictedTo: [
            USER_ROLE.PLATFORM_ADMIN,
            USER_ROLE.TOP_ADMIN
          ],
        },
        children: [
          // {
          //   title: 'Verification Management',
          //   icon: 'mdi-file-multiple',
          //   to: 'Test1',
          // },
          // {
          //   title: 'Vault Adjustments',
          //   icon: 'mdi-file-multiple',
          //   to: 'Test1',
          // },
          // {
          //   title: 'Vault Collections',
          //   icon: 'mdi-file-multiple',
          //   to: 'Test1',
          // },
        ]
      },
      {
        title: 'Estate Operations',
        to: 'changeorder',
        icon: 'mdi-chevron-up',
        meta: {
          restrictedTo: [
            USER_ROLE.PLATFORM_ADMIN,
            USER_ROLE.TOP_ADMIN

          ],
        },
        children: [
          {
            title: 'Site Management',
            icon: 'mdi-application-cog-outline',
            to: 'sitemanagement',
          },
          {
            title: 'Security Management',
            icon: 'mdi-lock',
            to: 'paythingssecurityactions',
          },
          {
            title: 'Pickup Management',
            icon: 'mdi-car-cog',
            to: 'paythingspickupactions',
          },
          // {
          //   title: 'Check Management',
          //   icon: 'mdi-file-multiple',
          //   to: 'Test1',
          // },
          // {
          //   title: 'Ops Report Grp',
          //   icon: 'mdi-file-multiple',
          //   to: 'Test1',
          // },
          {
            title: 'Machine Learning',
            icon: 'mdi-robot-happy-outline',
            to: 'MLManagement',
          },
          
        ]
      },
      {
        title: 'Package Verification',
        to: 'changeorder',
        icon: 'mdi-chevron-up',
        meta: {
          restrictedTo: [
            USER_ROLE.PLATFORM_ADMIN,
            USER_ROLE.TOP_ADMIN

          ],
        },
        children: [
          {
            title: 'Package Receipt',
            to: 'PackageVerification',
            icon: 'mdi-package-variant',
            meta: {
              restrictedTo: [
                USER_ROLE.PLATFORM_ADMIN,
                USER_ROLE.TOP_ADMIN

              ],
            },
          },
          {
            title: 'Package Validation',
            to: 'PostalPackageValidation',
            icon: 'mdi-package-variant-remove',
            meta: {
              restrictedTo: [
                USER_ROLE.PLATFORM_ADMIN,
                USER_ROLE.TOP_ADMIN

              ],
            },
          },
        ]
      },
    ],
  },

  {
    title: 'FI',
    icon: 'mdi-bank',
    group: 'tables',
    meta: {
      restrictedTo: [
        USER_ROLE.PLATFORM_ADMIN,
        USER_ROLE.TOP_ADMIN,
        USER_ROLE.CORPORATE,
        USER_ACCESS.CHANGEORDERMANAGEMENT
      ],
    },
    children: [
      {
        title: 'Change Order Admin',
        to: 'FIchangeorderadmin',
        icon: 'mdi-bank-transfer',
        meta: {
          restrictedTo: [
            USER_ROLE.PLATFORM_ADMIN,
            USER_ROLE.TOP_ADMIN,
            USER_ROLE.CORPORATE,
            USER_ACCESS.CHANGEORDERMANAGEMENT
          ],
        },
      },
      // {
      //   title: 'FI Report EOD',
      //   to: 'Fieod',
      //   icon: 'mdi-file-clock',
      //   meta: {
      //     restrictedTo: [
      //       USER_ROLE.PLATFORM_ADMIN,
      //       USER_ROLE.TOP_ADMIN
      //     ],
      //   },
      // },
      {
        title: 'FI Reports',
        to: 'Fieodreports',
        icon: 'mdi-file-clock',
        meta: {
          restrictedTo: [
            USER_ROLE.PLATFORM_ADMIN,
            USER_ROLE.TOP_ADMIN,
            USER_ROLE.CORPORATE,
            USER_ACCESS.CHANGEORDERMANAGEMENT
          ],
        },
      },
      {
        title: 'FI Settings',
        to: 'FIActions',
        icon: 'mdi-file-clock',
        meta: {
          restrictedTo: [
            USER_ROLE.PLATFORM_ADMIN,
            USER_ROLE.TOP_ADMIN,
            USER_ROLE.CORPORATE,
            USER_ACCESS.CHANGEORDERMANAGEMENT
          ],
        },
      },

    ],
  },
  {
    title: 'Accounting',
    icon: 'mdi-account-cash',
    group: 'tables',
    children: [
      {
        title: 'Site Billing Mgt',
        to: 'PaythingsBillingInfo',
        icon: 'mdi-file-cog',
        meta: {
          restrictedTo: [
            USER_ROLE.PLATFORM_ADMIN,
            USER_ROLE.TOP_ADMIN

          ],
        },
      },
      {
        title: 'Billing Groups',
        to: 'PaythingsBillingsGroups',
        icon: 'mdi-file-multiple',
        meta: {
          restrictedTo: [
            USER_ROLE.PLATFORM_ADMIN,
            USER_ROLE.TOP_ADMIN

          ],
        },
      },
      {
        title: 'Billing Client Profiles',
        to: 'PaythingsBillingClients',
        icon: 'mdi-file-account',
        meta: {
          restrictedTo: [
            USER_ROLE.PLATFORM_ADMIN,
            USER_ROLE.TOP_ADMIN

          ],
        },
      },
      {
        title: 'Billing Billing Rates',
        to: 'PaythingsBillingRates',
        icon: 'mdi-file-chart',
        meta: {
          restrictedTo: [
            USER_ROLE.PLATFORM_ADMIN,
            USER_ROLE.TOP_ADMIN

          ],
        },
      },
      {
        title: 'System Client Invoices',
        to: 'PaythingsClientInvoices',
        icon: 'mdi-account-cog',
        meta: {
          restrictedTo: [
            USER_ROLE.PLATFORM_ADMIN,
            USER_ROLE.TOP_ADMIN

          ],
        },
      },
      {
        title: 'System Invoices',
        to: 'PaythingsReportsInvoices',
        icon: 'mdi-archive-cog',
        meta: {
          restrictedTo: [
            USER_ROLE.PLATFORM_ADMIN,
            USER_ROLE.TOP_ADMIN

          ],
        },
      },
    ],
  },
  {
    title: 'Package Verification',
    icon: 'mdi-package-variant-closed-check',
    group: 'tables',
    children: [
      {
        title: 'Package Receipt',
        to: 'PackageVerification',
        icon: 'mdi-package-variant',
        meta: {
          restrictedTo: [
            USER_ROLE.PLATFORM_ADMIN,
            USER_ROLE.TOP_ADMIN

          ],
        },
      },
      {
        title: 'Package Validation',
        to: 'PostalPackageValidation',
        icon: 'mdi-package-variant-remove',
        meta: {
          restrictedTo: [
            USER_ROLE.PLATFORM_ADMIN,
            USER_ROLE.TOP_ADMIN

          ],
        },
      },
    ],
  },
  {
    title: 'Cash Connect',
    icon: 'mdi-cash-sync',
    group: 'tables',
    children: [
      {
        title: 'Site Reports',
        to: 'CCSiteReports',
        icon: 'mdi-chart-box',
        meta: {
          restrictedTo: [
            USER_ROLE.PLATFORM_ADMIN,
            USER_ROLE.TOP_ADMIN,
            USER_ROLE.CASH_CONNECT

          ],
        },
      },
      {
        title: 'Cash Connect Config',
        to: 'cashconnectconfig',
        icon: 'mdi-wrench',
        meta: {
          restrictedTo: [
            USER_ROLE.PLATFORM_ADMIN,
            USER_ROLE.TOP_ADMIN,
            USER_ROLE.CASH_CONNECT

          ],
        },
      },
      {
        title: 'Cash Levels',
        to: 'ccreportscashlevels',
        icon: 'mdi-cash-marker',
        meta: {
          restrictedTo: [
            USER_ROLE.PLATFORM_ADMIN,
            USER_ROLE.CASH_CONNECT,
            USER_ROLE.TOP_ADMIN

          ],
        },
      },
      {
        title: 'CC Reports Group',
        to: 'CCReportsOperationsGroup',
        icon: 'mdi-account-group',
        meta: {
          restrictedTo: [
            USER_ROLE.PLATFORM_ADMIN,
            USER_ROLE.CASH_CONNECT,
            USER_ROLE.TOP_ADMIN

          ],
        },
      },

    ],
  },
  {
    title: 'Change System',
    icon: 'mdi-list-box',
    group: 'tables',
    meta: {
      restrictedTo: [
        USER_ROLE.PLATFORM_ADMIN,
        USER_ROLE.TOP_ADMIN,
        USER_ROLE.MANAGER,
        USER_ROLE.STOREMANAGER,
        USER_ROLE.GROUPMANAGER,
        USER_ACCESS.CHANGEORDERMANAGEMENT,
        USER_ACCESS.CHANGEORDERALLOWED
      ],
    },
    children: [
      {
        title: 'Change Order Providers',
        to: 'changeorderprovider',
        icon: 'mdi-account',
        meta: {
          restrictedTo: [
            USER_ROLE.PLATFORM_ADMIN,
            USER_ROLE.TOP_ADMIN,
            USER_ROLE.CORPORATE,
            USER_ROLE.MANAGER,
            USER_ROLE.STOREMANAGER,
            USER_ROLE.GROUPMANAGER,
            USER_ACCESS.CHANGEORDERMANAGEMENT,
            USER_ACCESS.CHANGEORDERALLOWED
          ],
        },
      },
      {
        title: 'Change Order Configuration',
        to: 'changeorderconfig',
        icon: 'mdi-account',
        meta: {
          restrictedTo: [
            USER_ROLE.PLATFORM_ADMIN,
            USER_ROLE.TOP_ADMIN,
            USER_ROLE.CORPORATE,
            USER_ROLE.MANAGER,
            USER_ROLE.STOREMANAGER,
            USER_ROLE.GROUPMANAGER,
            USER_ACCESS.CHANGEORDERMANAGEMENT,
            USER_ACCESS.CHANGEORDERALLOWED
          ],
        },
      },
      {
        title: 'Change Order Mgt',
        to: 'changeordermanagement',
        icon: 'mdi-account',
        meta: {
          restrictedTo: [
            USER_ROLE.PLATFORM_ADMIN,
            USER_ROLE.TOP_ADMIN,
            USER_ROLE.CORPORATE,
            USER_ROLE.MANAGER,
            USER_ROLE.STOREMANAGER,
            USER_ROLE.GROUPMANAGER,
            USER_ACCESS.CHANGEORDERMANAGEMENT,
            USER_ACCESS.CHANGEORDERALLOWED
          ],
        },
      },
      {
        title: 'Change Order Admin',
        to: 'FIchangeorderadmin',
        icon: 'mdi-bank-transfer',
        meta: {
          restrictedTo: [
            USER_ROLE.PLATFORM_ADMIN,
            USER_ROLE.TOP_ADMIN,
            USER_ROLE.CORPORATE,
            USER_ACCESS.CHANGEORDERMANAGEMENT
          ],
        },
      },
    ],
  },  
  {
    title: 'Change Order',
    icon: 'mdi-list-box',
    group: 'tables',
    meta: {
      restrictedTo: [
        USER_ROLE.PLATFORM_ADMIN,
        USER_ROLE.TOP_ADMIN,
        USER_ROLE.MANAGER,
        USER_ROLE.STOREMANAGER,
        USER_ROLE.GROUPMANAGER,
        USER_ACCESS.CHANGEORDERMANAGEMENT,
        USER_ACCESS.CHANGEORDERALLOWED
      ],
    },
    children: [
      {
        title: 'Change Order Mgt',
        to: 'changeordermanagement',
        icon: 'mdi-account',
        meta: {
          restrictedTo: [
            USER_ROLE.PLATFORM_ADMIN,
            USER_ROLE.TOP_ADMIN,
            USER_ROLE.CORPORATE,
            USER_ROLE.MANAGER,
            USER_ROLE.STOREMANAGER,
            USER_ROLE.GROUPMANAGER,
            USER_ACCESS.CHANGEORDERMANAGEMENT,
            USER_ACCESS.CHANGEORDERALLOWED
          ],
        },
      },
      {
        title: 'Change Order Admin',
        to: 'FIchangeorderadmin',
        icon: 'mdi-bank-transfer',
        meta: {
          restrictedTo: [
            USER_ROLE.PLATFORM_ADMIN,
            USER_ROLE.TOP_ADMIN,
            USER_ROLE.CORPORATE,
            USER_ACCESS.CHANGEORDERMANAGEMENT
          ],
        },
      },
    ],
  },
  // {
  //   title: 'Corp Management',
  //   icon: 'mdi-charts',
  //   group: 'tables',
  //   children: [
  //     {
  //       title: 'Postal Reports',
  //       to: 'changeorder',
  //       icon: 'mdi-account',
  //       meta: {
  //         restrictedTo: [
  //           USER_ROLE.PLATFORM_ADMIN,
  //           USER_ROLE.TOP_ADMIN

  //         ],
  //       },
  //     },


  //   ],
  // },
  {
    title: 'Admin',
    icon: 'mdi-cog',
    group: 'tables',
    children: [
      {
        title: 'Transfers',
        group: 'tables',
        meta: {
          restrictedTo: [
            USER_ROLE.PLATFORM_ADMIN,
            USER_ROLE.TOP_ADMIN
          ],
        },
        
        children: [
          {
            title: 'SafeAndSound',
            meta: {
              restrictedTo: [
                USER_ROLE.PLATFORM_ADMIN,
                USER_ROLE.TOP_ADMIN
              ],
            },
            children: [
              {
                title: 'SafeAndSound Daily Feed',
                icon: 'mdi-file-multiple',
                to: 'ssDailyFeed',
              },
              {
                title: 'SafeAndSound Config',
                icon: 'mdi-file-multiple',
                to: 'ssConfig',
              },
            ]
          },
          {
            title: 'Kapcharge',
            meta: {
              restrictedTo: [
                USER_ROLE.PLATFORM_ADMIN,
                USER_ROLE.TOP_ADMIN
              ],
            },
            children: [
              {
                title: 'Kapcharge Daily Feed',
                icon: 'mdi-file-multiple',
                to: 'KapchargeDailyFeed',
              },
              {
                title: 'Kapcharge Config',
                icon: 'mdi-file-multiple',
                to: 'KapchargeConfig',
              },
              {
                title: 'Kapcharge EODs',
                icon: 'mdi-file-multiple',
                to: 'KapchargeReportsEOD',
              },
              {
                title: 'Kapcharge CIT',
                icon: 'mdi-file-multiple',
                to: 'KapchargeReportsCIT',
              },
              {
                title: 'Kapcharge Cash Levels',
                icon: 'mdi-file-multiple',
                to: 'kapchargecashlevels',
              },

            ]
          },
          {
            title: 'FEED_V5',
            meta: {
              restrictedTo: [
                USER_ROLE.PLATFORM_ADMIN,
                USER_ROLE.TOP_ADMIN
              ],
            },
            children: [
              {
                title: 'V5 Daily Feed Data',
                icon: 'mdi-file-multiple',
                to: 'V5DailyFeed',
              },
              {
                title: 'V5 Sequence',
                icon: 'mdi-file-multiple',
                to: 'V5SequenceAdmin',
              },
              {
                title: 'V5 Sequence Published',
                icon: 'mdi-file-multiple',
                to: 'V5SequencePublished',
              },
            ]
          },
          {
            title: 'Namsys',
            meta: {
              restrictedTo: [
                USER_ROLE.PLATFORM_ADMIN,
                USER_ROLE.TOP_ADMIN
              ],
            },
            children: [
              {
                title: 'Namsys Daily Feed',
                icon: 'mdi-file-multiple',
                to: 'NamsysDailyFeed',
              },
              // {
              //   title: 'Namsys Transactions',
              //   icon: 'mdi-search',
              //   to: 'NamsysTransactions',
              // },
              {
                title: 'Namsys Config',
                icon: 'mdi-file-multiple',
                to: 'NamsysConfig',
              },
            ]
          },
          {
            title: 'QAPayments',
            icon: 'mdi-file-account',
            meta: {
              restrictedTo: [
                USER_ROLE.PLATFORM_ADMIN,
              ],
            },
          },
        ],
      },
      {
        title: 'Vaults',
        group: 'tables',
        meta: {
          restrictedTo: [
            USER_ROLE.PLATFORM_ADMIN,
            USER_ROLE.TOP_ADMIN
          ],
        },
        
        children: [
          {
            title: 'MiamiBank',
            meta: {
              restrictedTo: [
                USER_ROLE.PLATFORM_ADMIN,
                USER_ROLE.TOP_ADMIN
              ],
            },
            children: [
              {
                title: 'Miami Vault AI',
                icon: 'mdi-file-multiple',
                to: 'VaultAIMiami',
              },
            ]
          },
          {
            title: 'QAPayments',
            icon: 'mdi-file-account',
            meta: {
              restrictedTo: [
                USER_ROLE.PLATFORM_ADMIN,
              ],
            },
          },
        ],
      },
      {
        title: 'Setup Wizzards',
        to: 'usermanagement',
        icon: 'mdi-chevron-up',
        meta: {
          restrictedTo: [
            USER_ROLE.PLATFORM_ADMIN,
            USER_ROLE.TOP_ADMIN
          ],
        },
        children: [
          {
            title: 'New Postal Site',
            icon: 'mdi-file-multiple',
            to: 'FormWizardAddPostalSite',
          },
          {
            title: 'New Virtual Site',
            icon: 'mdi-file-multiple',
            to: 'FormWizardAddVirtualSite',
          },
          {
            title: 'New Smart Safe Site',
            icon: 'mdi-file-multiple',
            to: 'FormWizardAddSmartSafeSite',
          },
        ]
      },
      {
        title: 'System Monitoring',
        to: 'usermanagement',
        icon: 'mdi-chevron-up',
        meta: {
          restrictedTo: [
            USER_ROLE.PLATFORM_ADMIN,
            USER_ROLE.TOP_ADMIN

          ],
        },
        children: [
          {
            title: 'System Services',
            icon: 'mdi-wrench-cog',
            to: 'PaythingsReportsServices',
          },
          {
            title: 'Field Devices',
            icon: 'mdi-file-chart',
            to: 'PaythingsReportsDevices',
          },
          {
            title: 'Field Cash',
            icon: 'mdi-cash-multiple',
            to: 'PaythingsReportsCashLevels',
          },
          {
            title: 'Hardware',
            icon: 'mdi-laptop',
            to: 'PaythingsReportsHardware',
          },
        ]
      },
      {
        title: 'Estate Config',
        to: 'usermanagement',
        icon: 'mdi-chevron-up',
        meta: {
          restrictedTo: [
            USER_ROLE.PLATFORM_ADMIN,
            USER_ROLE.TOP_ADMIN
   
          ],
        },
        children: [
          {
            title: 'User Mgt',
            icon: 'mdi-account-group',
            to: 'usermanagement',
          },
          {
            title: 'Safe Management',
            icon: 'mdi-shield-lock',
            to: 'safemanagement',
          },
          {
            title: 'Postal Limits',
            icon: 'mdi-email-edit',
            to: 'PaythingsPostalManagement',
          },
          {
            title: 'Simulator',
            icon: 'mdi-file-multiple',
            to: 'simulator',
          },
        ]
      },
      {
        title: 'Financial Institutions',
        to: 'usermanagement',
        icon: 'mdi-chevron-up',
        meta: {
          restrictedTo: [
            USER_ROLE.PLATFORM_ADMIN,
            USER_ROLE.TOP_ADMIN

          ],
        },
        children: [
          {
            title: 'Institution Mgt',
            icon: 'mdi-file-multiple',
            to: 'PaythingsInstitutionManagement',
          },
        ]
      },
      {
        title: 'User Management',
        to: 'usermanagement',
        icon: 'mdi-account-group',
        meta: {
          restrictedTo: [
            USER_ROLE.PLATFORM_ADMIN,
            USER_ROLE.TOP_ADMIN

          ],
        },
      },
      {
        title: 'Safe Management',
        to: 'safemanagement',
        icon: 'mdi-shield-lock',
        meta: {
          restrictedTo: [
            USER_ROLE.PLATFORM_ADMIN,
            USER_ROLE.TOP_ADMIN

          ],
        },
      },
      {
        title: 'FormWizard',
        to: 'FormWizard',
        icon: 'mdi-account-eye',
        meta: {
          restrictedTo: [
            USER_ROLE.PLATFORM_ADMIN,
            USER_ROLE.TOP_ADMIN

          ],
        },
      },
    ],
    
  },
  {
    title: 'Super Admin',
    icon: 'mdi-flash',
    group: 'tables',
    children: [
      {
        title: 'Onboard Safe',
        to: 'onboard',
        icon: 'mdi-account-eye',
        meta: {
          restrictedTo: [
            USER_ROLE.PLATFORM_ADMIN,
            USER_ROLE.TOP_ADMIN

          ],
        },
      },
      {
        title: 'Audit Log',
        to: 'auditlog',
        icon: 'mdi-account-eye',
        meta: {
          restrictedTo: [
            USER_ROLE.PLATFORM_ADMIN,
            USER_ROLE.TOP_ADMIN

          ],
        },
      },
    ],
  },
]
